<template>
  <div class="home-page-bd" >
	<div :style="'background:'+bgColor">
		<!-- <Carousel
		ref="carousel"
		:list-data="indexConfig.imageList"
		:waiting-time="3000"
		out-animate="fadeOutBottomRight"
		:autoPlay="true"
		:style="{height: '700px'}"
		>
			<template slot-scope="{ record, index }">
				<div :style="{background: index % 2 === 0 ? '#000' : '#000'}" class="list-item">
					<img :src="indexConfig.imageList[index].url" >
					
					<transition name="slide-fade">
						<div v-if="show" class="image-text">
							<div >{{indexConfig.imageList[index].name}}</div>
						</div>
			
					</transition>
					<transition name="slide-fade">
						<div v-if="show" class="info-text" style="top:450px">
							<div >{{indexConfig.imageList[index].name}}</div>
						</div>
						
					</transition>
					<button @click="show = !show">
    Toggle render
  </button>
				</div>
			</template>
		</Carousel> -->
		<div class="banner">
			<div class="item " v-for="(image,index) in dataList" :key="index"  >
				<transition name="fade">
					<div v-if="index===currentIndex" >
						<img v-if="image.url" :src="image.url">
					</div>
				</transition>
				<transition name="slide-fade">
					<div v-if="image.show" class="image-text" >
						<div >{{image.name}}</div>
					</div>
				</transition>
				<transition name="slide-fade">
					<div v-if="image.show&&!!image.info" class="image-info" >
						<div >{{image.info}}</div>
					</div>
				</transition>
			</div>
			
		</div>
		<!-- <el-carousel :interval="4000" type="card" height="400px">
			<el-carousel-item v-for="(item,index) in companyList" :key="index">
				<div class="image" v-if="item.companyImageList.length!==0" :style="'width:'+item.companyImageSize+'px;height:'+item.companyImageHeight+'px'"><img :src="item.companyImageList[0].url"></div>
			</el-carousel-item>
		</el-carousel> -->
		<div class="company-list-wrapper">
			
			<div class="center-block" :style="{left:`-${leftVal}px`,transition:`${ition}s`}">
				<div v-for="(imgs,index) in imgList" :key="index" class="warpper">
					<div class="item" v-for="(item,index1) in imgs" :key="index1" @click="goCompany(item)" v-show="!!item.companyName" :style="'width:'+item.companyImageSize+'px;height:'+item.companyImageHeight+'px'">
						<div class="image" v-if="item.companyImageList.length!==0" ><img :src="item.companyImageList[0].url"></div>
						<div class="title" v-if="lang==='zh'">{{item.companyName}}</div>
						<div class="title" v-if="lang==='en'">{{item.enCompanyName}}</div>
						<div class="title" v-if="lang==='ja'">{{item.jaCompanyName}}</div>
					</div>
				</div>
				<!-- <div class="warpper">
					<div class="item" v-for="(item,index1) in imgList[0]" :key="index1" @click="goCompany(item)" v-show="!!item.companyName" :style="'width:'+item.companyImageSize+'px;height:'+item.companyImageHeight+'px'">
						<div class="image" v-if="item.companyImageList.length!==0" ><img :src="item.companyImageList[0].url"></div>
						<div class="title">{{item.companyName}}</div>
					</div>
				</div> -->
				
			</div>
			
			<div class="dot-warp" v-if="companyList.length>3">
				<div class="dot" :class="{on:imgShow===index}" :style="imgShow===index?'background:'+(indexConfig.companInfo&&indexConfig.companInfo.pointColor)+'border: 2px solid '+(indexConfig.companInfo&&indexConfig.companInfo.pointColor):''" v-for="(item,index) in imgList.length" @click="changeCompany(item,index)"></div>
			</div>
		</div>
		<div class="company-Info-wrapper" :style="'background:'+bdColor">
			
			<div class="content-bd1">
				<div class="text">
					<!-- <div class="header-c" :style="'border-bottom: 2px solid '+allColor">{{indexConfig.companInfo.title}}</div> -->
					<div class="content-c" :style="'font-size:'+font.indexContentSize+';color:'+font.indexContentColor" v-html="detailCompanyInfo.content"></div>
					<!-- {{indexConfig.companInfo.content}} -->
					<div class="btn" :style="'background:'+allColor" @click="goUrl('/about')" > 

						<div v-if="lang==='zh'"> 查看详情</div>
						<div v-if="lang==='ko'"> 상세 한 상황 을 살펴보다</div>
						<div v-if="lang==='en'"> View Details</div>
						<div v-if="lang==='ja'"> 詳細を表示</div>
						<span class="i"></span>
					</div>
				</div>
				<div class="r-image-c">
					<img  class="img" :src="indexConfig.companInfo.image[0].url" alt="" v-if="indexConfig.companInfo&&indexConfig.companInfo.image.length!==0">
				</div>
				
			</div>
		</div>
		<div class="news-wrapper">
			<div class="news-bd">
				<div class="news-list" style="float:left">
					<div style="display:flex;flex-direction: row">
						<div class="header-c" :style="'border-bottom: 2px solid '+allColor+';font-weight: 600;'" >		
							<div v-if="lang==='zh'">行业新闻</div>
							<div v-if="lang==='en'">Industry News</div>
							<div v-if="lang==='ja'">業界ニュース</div>
						</div>
					</div>
					<div style="height:145px;overflow: hidden; ">
						<div class="news" v-for="(news,index) in newsList1" :key="index" @click="getDetail(news)" >
							<!-- <div style="min-height:50px;float:left">
								<div :style="'background:'+allColor" :class="[{left:indexConfig.newsTipType==='1'},{round:indexConfig.newsTipType==='2'},{smallRound:indexConfig.newsTipType==='3'}]"></div>
							</div> -->
							<div class="right">
								<div class="title" :style="'font-size:'+font.newsTitleSize+';color:'+font.newsTitleColor+';margin-bottom:16px'">{{news.newsTitle}}</div>
								<!-- <div class="content" ></div> -->
								<!-- v-html="news.newsContent" -->
							</div>
						</div>

					</div>
					
					<div style="display:flex;flex-direction: row;margin-top: 26px;" >
						<div class="header-c" :style="'border-bottom: 2px solid '+allColor+';font-weight: 600;'">
							{{indexConfig.newsTitle}}
						</div>
					</div>
					<div  style="height:136px; overflow: hidden; ">
						<div class="news" v-for="(news,index) in newsList" :key="index"  @click="getNewsDetail(news)">
							<!-- <div style="min-height:50px;float:left">
								<div :style="'background:'+allColor" :class="[{left:indexConfig.newsTipType==='1'},{round:indexConfig.newsTipType==='2'},{smallRound:indexConfig.newsTipType==='3'}]"></div>
							</div> -->
							<div class="right">
								<div class="title" :style="'font-size:'+font.newsTitleSize+';color:'+font.newsTitleColor+';margin-bottom:16px'">{{news.newsTitle}}</div>
								<!-- <div class="content" v-html="news.newsContent">
									
								</div> -->
							</div>
						</div>
					</div>
					
					
				</div>
				<div class="image-list">
					<!-- +indexConfig.newsRightImageWidth -->
					<div v-for="(item,index) in indexConfig.newsRightImage " class="one-img" :style="'width:47%'+'px;height:'+indexConfig.newsRightImageHeight+'px'">
						<img :src="item.url">
					</div>
				</div>
			</div>
		</div>
		<p-bottom :lang="lang"></p-bottom>
	</div>

  </div>
</template>
<!-- 跑马灯 公司切换效果 https://blog.csdn.net/m0_59224033/article/details/126675569 -->
<script>
	import image from '../assets/images/slide.jpg';
	import image1 from '../assets/images/slide-1.jpg';
	import image2 from '../assets/images/fabric.jpg';
	import company1 from '../assets/images/demir-celik-sanayi.jpg';
import { Carousel } from '@digi1874/vue-carousel'
import '@digi1874/vue-carousel/dist/carousel.css'
import 'animate.css/source/_vars.css'
import 'animate.css/source/_base.css'
import 'animate.css/source/fading_entrances/fadeInLeft.css'
import 'animate.css/source/fading_entrances/fadeIn.css'
import 'animate.css/source/fading_exits/fadeOut.css'
import 'animate.css/source/bouncing_exits/bounceOutLeft.css'
import slider from 'vue-concise-slider'// 引入slider组件
export default { 
  name: 'Main',
  components: { Carousel },
  props:{
  		lang:{},
  },
  data() {
    return {
		dataList:[{url:''}],
    //   imageList1:[
	// 	  {url:image1,onUrl:image1On,zh:"冶金用耐火材料",ko:"야금용 내화 재료",jp:'冶金用耐火材料',tip:'Refractories for metallurgy',en:'Refractories for metallurgy',href:'/refractoryProducts'},
	// 	  {url:image2,onUrl:image2On,zh:"合成材料和先进陶瓷",ko:"합성 재료와 선진 도자기",jp:'合成材料と先進陶磁器',tip:'Synthetic Materials and Advanced Ceramics',en:'Synthetic Materials and Advanced Ceramics',href:'/syntheticRawMaterials'},
	// 	  {url:image3,onUrl:image3On,zh:"高分子化工",ko:"고분자 화공",jp:'高分子化学工業',tip:'Polymer Chemical Industry',en:'Polymer Chemical Industry',href:'/highPolymer'},
	//   ],
	  currentImage:1,
	  currentIndex: 0,
	  currentLanguage:"",
	  imageConfig:{},
	  companyList:[],
	  companyInfoBackgroundColor:'#262626',
	  allColor:'#ff121e',
	  companInfo:{
		title:'自立股份',
	  	content:"SÖRMAŞ, Söğüt Refrakter Malzemeleri A.Ş., 1976 yılında refrakter malzeme üretmek amacıyla kurulmuş çok ortaklı halka açık bir şirkettir. 1980 yılında üretime başlayan şirket günümüzde pişmiş şamot, yüksek alumina, izole, andaluzit, alumina-SiC, korund, krom-korund, magnezit, kromit, magnezit-krom, spinel ve reçine bağlı alumina-karbon, alumina-SiC-karbon, alumina-magnezia-karbon, magnezya-karbon tuğlalar ile örgü harçları ve dökme, dövme, püskürtme monolitik malzemeleri üretmektedir.Yıllık üretim kapasitesi 60.000 ton olan SÖRMAŞ'ın başlıca müşterileri Demir-Çelik, Çimento, Cam, Kireç, Metal ve Seramik üreticileri ile kuvvet santralları, rafineriler ve atık",
		image:image2	
	  },
	  show:true,
	  indexConfig:{
		companInfo:{backgroundColor:'#000',image:[{url:''}],title:''},
		bottomInfo:{image:[{url:''}]}
	  },
	  pageConfigPageTotal:{
		total:null,
		pageSize:10,
		pageNo:1,
		pageTotal:null
	  },
	  newsList:[],
	  newsList1:[],
	  index:0,
	  timer: null,
	  font:{},
	  bdColor:'',
	  detailCompanyInfo:{},
	  bgColor:'#fff',
	  currentSelectNews:0,
	  ition:1.8, //设置轮播过度时间
	  imgShow:0, //当前图片的索引
	  imgWidth:1500, //图片的宽度
	  leftVal:0, //轮播图盒子的偏移值
	  flage:true, //节流参数
	  start:null, //自动执行下一张定时器
	  
    }
  },
  mounted(){
	  this.getLanguage()
		
	  this.handelBg()
	  this.runInv()
	  
	//   this.$nextTick(()=>{
	// 	this.initCompanyImage()
	//   })
		
  },
  computed: {
	
	//上一张
	prevIndex() {
		if(this.currentIndex == 0) {
			return this.dataList.length - 1;
		}else{
			return this.currentIndex - 1;
		}
	},
	//下一张
	nextIndex() {
		if(this.currentIndex == this.dataList.length - 1) {
			return 0;
		}else {
			return this.currentIndex + 1;
		}
	},
	showImageTitle(){
		return function(index){
			
			if(index===this.currentIndex){
				setTimeout(()=>{
					return true
				},1000)
			}    
		}  
	},
	imgList(){
		let arr = []
		let num = 3
		if(this.companyList.length){
			for(let i=0;i<this.companyList.length;i+=num){
				arr.push(this.companyList.slice(i,i+num))
			}
		}
		return arr
	}
  },
  methods: {
	fetchIndexData(){
		this.getImage()
		this.getFontConfig()
	  	this.getCompanyList()
	},
	handelBg(){
		if(localStorage.getItem('backgroudColor')){
			this.bgColor = JSON.parse(localStorage.getItem('backgroudColor')).indexBdColor
		}
	},
	getNewsDetail(news){
		localStorage.setItem('newsDetailData', JSON.stringify({id:news._id}))
		  this.$router.push("/newsDetail/"+this.lang)
	},
	initCompanyImage(){
		this.start = setInterval(()=>{
			this.nextFun()
		},4500)
	},
	changeCompany(item,index){
		this.ition = 0.8
		this.leftVal = index*1550
		this.imgShow = index
	},
	nextFun(){
		console.log('leftVal',this.leftVal,this.companyList.length)
		if(this.leftVal>(this.companyList.length-3)*this.imgWidth){
			this.ition = 0.8
			this.leftVal = this.imgWidth+30
			this.imgShow = 0
			setTimeout(()=>{
				this.ition = 0
				this.leftVal = 0
			},this.ition*1000)
		}else{ // 判断图片不是最后一张   执行
			this.ition = 0.8
			this.leftVal+= this.imgWidth+30
			this.imgShow++
		}
	},
	pervFun(){
		if(this.leftVal===0){
			this.ition = 0
			
			this.imgShow = this.imgList.length-1
			this.leftVal = (this.imgList.length)*this.imgWidth
			setTimeout(()=>{
				this.ition = 0.8
				this.leftVal-= this.imgWidth
			},this.ition*1000)
		}else{ // 判断图片不是最后一张   执行
			this.ition = 0.8
			this.leftVal-= this.imgWidth
			this.imgShow--
		}
	},
	selectTab(index){
		this.currentSelectNews=index
		this.fetch(index)
	},
	goCompany(item){
		console.log(item)
		this.$router.push("/RefractoryProducts/"+this.lang+'?id='+item._id)
	},
	async getImage(){
		const res=await this.$http.post('/indexConfig',{la:this.currentLanguage})
		this.indexConfig = res.data||{}
		this.allColor = this.indexConfig.allColor
		this.fetch(0)
		this.fetch(1)
		this.dataList = this.indexConfig.imageList
		this.dataList.forEach((item,index)=>{
			if(index ===0){
				this.$set(item,'show',true)
			}else{
				this.$set(item,'show',false)
			}
			
		})
		// this.dataList.push({videoUrl:'https://26106453.s21v.faiusr.com/58/ABUIABA6GAAgwpqxmAYog62x8AY.mp4'})
		this.bdColor = this.indexConfig.companInfo.backgroundColor
		console.log(this.indexConfig)
	},
	async getCompanyInfo(){
		const res  =  await this.$http.post('groupInfoList',{la:this.lang,type:0})
		this.detailCompanyInfo = res.data[0]||{}	
	},
	async getCompanyList(){ //目前处理 ：公司部分多个 语言版本，所有语言内置在 公司详情内 ，后台创建的公司默认都是  zh
		const res  =  await this.$http.post('companyList',{la:'zh'})
		this.companyList = res.data||{}	
	},
	runInv() {
		this.timer = setInterval(() => {
			this.gotoPage(this.nextIndex)
		}, 5000)
	},
	getDelay(index){
		let show = false
		if(index===this.currentIndex){
			setTimeout(()=>{
				show =  true
			},1000)
		}
		return show
	},
	gotoPage(index) {
		this.currentIndex = index;
	},
	async fetch(type){
		let data={
			pageSize:10,
			pageNo:this.pageConfigPageTotal.pageNo,
			language:this.lang,
			type:type
		}
		const res=await this.$http.post('newsList',data);
		
		if(type==0){
			this.newsList=res.data.list.slice(0,4);
		}else if(type==1){
			this.newsList1=res.data.list.slice(0,4);
		}
		this.pageConfigPageTotal={
			total:res.data.pageTotal,
			pageSize:res.data.pageSize,
			pageNo:res.data.pageNo,
			pageTotal:res.data.pageAcount
		}
	},
	getDetail(news){
		localStorage.setItem('newsDetailData', JSON.stringify({id:news._id}))
		this.$router.push("/newsDetail/"+this.lang)
	},
	goUrl(url){
		console.log(this.$router)
		this.$router.push(url+'/'+this.currentLanguage)
	},
  	getIndex(index){
  		console.log(index)
  	},
	getLanguage () {	    
	    this.currentLanguage=this.lang;
		this.currentIndex = 0
		this.getImage()
		this.getCompanyInfo()
		this.fetchIndexData()
	},
	async getFontConfig(){
		const res = await  this.$http.post('fontConfig')
		const fontContent = res.data
		if(fontContent.length!==0){
			this.font = fontContent[0]
			console.log('fftt',this.font)
			
		}
	}, 
  },
  watch: {
  		// 如果路由有变化，会再次执行该方法
  		"$route": "getLanguage",
		currentImage(val, oldVal){
			console.log("a: "+val, oldVal);
			
		},
		currentIndex(val,oldVal){
			this.dataList[oldVal].show = false
			setTimeout(()=>{
				this.dataList[val].show = true
			},1500)
		}
	
  	}
  
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.list-item{
		height: 700px;
		width: 100%;
		margin: 0 auto;
		overflow: hidden;
		img{
			position: relative;
		}
	}
	.slide-fade-enter-active {
		transition: all 1.3s ease;
	}
	.slide-fade-leave-active {
		transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.slide-fade-enter
	/* .slide-fade-leave-active for below version 2.1.8 */ {
		transform: translateX(1000px);
		opacity: 0;
	}
	.slide-fade-leave-to{
		transform: translateX(-1000px);
		opacity: 0;
	}
	.fade-enter-active, .fade-leave-active {
	transition: opacity 2s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
	}
	.banner {
        width: 100%;
		height: 740px;
		// height: 36.5vw;
		position: relative;
		overflow: hidden;
		img {
			position: absolute;
			left:0;
			width:1920px;
  			margin:0 calc(50% - 960px);
			
		}
		.pic{
			-webkit-animation-name: animateImg;
			-webkit-animation-timing-function: ease-in-out;
			-webkit-animation-iteration-count: infinite;
			-webkit-animation-duration: 12s;
			-webkit-animation-direction: alternate;
		}
		@keyframes animateImg{
		 	0% {
				opacity:1;
			}
			25% {
				opacity:0;
			}
			50% {
				opacity: 0;    
			}
			75% {
				opacity:1;
			}
		}
    }
  
	.image-text{
		color: white;
    	// background: rgba(0, 0, 0, 0.5);
		font-size: 48px;
		line-height: 50px;
		padding: 5px 10px;
		border-width: 0px;
		left: 151px;
		top: 350px;
		position:absolute;
	}
	.image-info{
		color: white;
    	// background: rgba(0, 0, 0, 0.5);
		font-size: 20px;
		line-height: 22px;
		padding: 5px 10px;
		border-width: 0px;
		left: 151px;
		top: 430px;
		position:absolute;
	}
	.company-list-wrapper{
		
		margin: -80px auto 0;
		padding-bottom: 60px;
		overflow: hidden;
		height: 340px;
		width: 1500px;
		position: relative;
		
		.center-block{
            position: absolute;
            display: flex;
            height: 310px;
			justify-content: flex-start;
			.warpper{
				display: flex;
				flex-direction: row;
			}
			.item{	
				display: flex;
				flex-direction: column;
				margin-right: 16px;
				.image{
					
					// height: 171px;
					    height: 80%;
					overflow: hidden;
					img{
						display: block;
						width: 100%;
						height: 100%;
						border: 2px solid white;
						-webkit-box-sizing: border-box;
						-moz-box-sizing: border-box;
						-ms-box-sizing: border-box;
						-o-box-sizing: border-box;
						box-sizing: border-box;
						-webkit-transition: all 0.5s ease 0s;
						-moz-transition: all 0.5s ease 0s;
						-o-transition: all 0.5s ease 0s;
						-ms-transition: all 0.5s ease 0s;
						transition: all 0.5s ease 0s;
						-webkit-transform: scale(1);
						-ms-transform: scale(1);
						transform: scale(1);
					}
					img:hover{
						-webkit-transition: all 0.5s ease 0s;
						-moz-transition: all 0.5s ease 0s;
						-o-transition: all 0.5s ease 0s;
						-ms-transition: all 0.5s ease 0s;
						transition: all 0.5s ease 0s;
						-webkit-transform: scale(0.9);
						-ms-transform: scale(0.9);
						transform: scale(0.9);
					}
				}
				.title{
					font-size: 20px;
					color: #262626;
					font-weight: 600;
					text-align: center;
					line-height: 50px;
				}
			}
			
		}
	}
	.dot-warp{
		list-style: none;
		position: absolute;
		text-align: center;
		width: 100%;
		bottom: 8px;
		.dot{
			display: inline-block;
			margin-left: 5px;
			background: #f2f2f2;
			-webkit-border-radius: 50%;
			-moz-border-radius: 50%;
			border-radius: 50%;
			width: 16px;
			height: 16px;
			border: 2px solid #262626;
			cursor: pointer;
		}
		.dot.on{
			background: #ff121e;
    		border: 2px solid #ff121e;
		}
	}
	.news-wrapper{
		padding: 60px 12px;
		overflow: hidden;
		position: relative;
		max-width: 1542px;
		margin:0 auto;
		.news-bd{
			display: flex;
			justify-content: center;
			.news-list{
				width: 706px;
			}
			.image-list{
				width: 50%;
				margin-left: 60px;
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				.one-img{
					float: left;
					    width: 48%;
						margin-right: 3px;
						margin-bottom: 3px;
						border-radius: 4px;
						overflow: hidden;
					img{
						display: block;
						object-fit: cover;
						width: 100%;
						height: 100%;
					}
				}
				
			}
			.header-c{
				font-size: 17px;
				padding-bottom: 5px;
				display: table;
				padding-right: 40px;
				margin-bottom: 15px;
				font-weight: 500;
				color:#262626;
				cursor: pointer;
			}
			.news{
				// margin-bottom:18px;
			    cursor: pointer;
				.left{
					min-width: 55px;
					margin-top: 5px;
					background: #ff121e;
					color: white;
					padding: 0 0 5px;
					text-align: center;
					float: left;
					line-height: 34px;
					font-size: 30px;
					min-height: 55px;
					margin-right:18px;
				}
				.round{
					min-width: 55px;
					margin-top: 5px;
					background: #ff121e;
					color: white;
					padding: 0 0 5px;
					text-align: center;
					float: left;
					border-radius: 50%;
					line-height: 34px;
					font-size: 30px;
					min-height: 55px;
					margin-right:18px;
				}
				.smallRound{
					min-width: 20px;
					margin-top: 5px;
					background: #ff121e;
					color: white;
					border-radius: 50%;
					padding: 0 0 5px;
					text-align: center;
					float: left;
					line-height: 34px;
					font-size: 30px;
					min-height: 20px;
					margin-right:18px;
				}
				.right{
					.title{
						font-size: 16px;
						margin-bottom: 3px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
					.content{
						height: 40px; 
						overflow: hidden;
					
					}
					.content h2{
						line-height: 40px;
					}
					.content p{
						font-size: 14px;
						overflow: hidden;
						color:#262626;
						line-height: 40px;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
				
			}
		}	
	}
	.r-image-c{
		.img{
			display: block;
			object-fit: cover;
			width: 100%;
			height: 100%;
		}
	}
	.company-Info-wrapper{
		padding: 60px 0;
		overflow: hidden;
		position: relative;
		.content-bd1{
			max-width: 1568px;
			margin: 0 auto;
			padding: 0 20px;
			.text{
				.header-c{
					font-size: 20px;
					padding-bottom: 5px;
					display: table;
					padding-right: 40px;
					margin-bottom: 15px;
					font-weight: 500;
					color:#fff
				}
				.content-c{
					width: 41%;
					color: #fff;
					line-height: 22px;
					font-size: 14px;
					position: relative;
					overflow: hidden;
					height: 201px;
				}
				.btn{
					
					color: white;
					display: table;
					padding: 0 10px;
					line-height: 30px;
					text-decoration: none;
					margin-top: 20px;
					font-size: 14px;
					cursor: pointer;
					.i{
						font: normal normal normal 14px/1 FontAwesome;
						font-size: inherit;
						text-rendering: auto;
						-webkit-font-smoothing: antialiased;
						-moz-osx-font-smoothing: grayscale;
						transform: translate(0,0);
					}
				}
			}
		}
		.img{
			position: absolute;
			width: 50%;
			bottom: 0;
			right: 0;
			top: 0;
			height: 100%;
			display: block;
		}
	}
	
</style>
